import { defineMessages } from 'react-intl';

export default defineMessages({
  issues: {
    id: 'app.components.ShiftDetailCardRoutes.issues',
    defaultMessage:
      '{numberOfAssignments} {numberOfAssignments, plural, one {assignment} other {assignments}} • {errorCount} {errorCount, plural, one {error} other {errors}} • {warningCount} {warningCount, plural, one {warning} other {warnings}}',
  },
});
